
import { LanguageService } from "./language.service";
import { introJs } from '../lib/intro.js';
import { CommandsService } from "./commands.service";
import { async } from "@angular/core/testing";

declare var ace:any;

export class QuickStartService {

    private editor;
    private inputComponent;
    private headerComponent;
    private commandsService;
    private lang;
    private step;

    //variables to handle different quickstarters
    private intro;
    private introEditor;
    private introDebugger;

    //TODO: work in progress
    private prepareIntroDebugger() {
    }

    //TODO: work in progress
    private prepareIntroEditor() {
        this.introEditor.setOptions({
            steps: [
                {//1
                    element: '#root',
                    intro: this.lang.getLang()["editor1"],
                    position: 'left',
                },
                {//2
                    element: '#inputEditor',
                    intro: this.lang.getLang()["editor2"],
                    position: 'top',
                },
                {//3
                    element: '#canvasD',
                    intro: this.lang.getLang()["editor3"],
                    position: 'top',
                },
                {//4
                    element: '#inputEditor',
                    intro: this.lang.getLang()["editor4"],
                    position: 'top',
                },
                {//5
                    element: '#history',
                    intro: this.lang.getLang()["editor5"],
                    position: 'top',
                },
                {//6
                    element: '#editor',
                    intro: this.lang.getLang()["editor6"],
                    position: 'top',
                },
                {//7
                    element: '#canvasID',//non-existant elemtent. absicht
                    intro: this.lang.getLang()["editor7"],
                    position: 'top',
                },
                {//8
                    element: '#editor',
                    intro: this.lang.getLang()["editor8"],
                    position: 'top',
                },
                {//9
                    element: '#canvasID',
                    intro: this.lang.getLang()["editor9"],
                    position: 'top',
                },
                {//10
                    element: '#canasID',
                    intro: this.lang.getLang()["editor10"],
                    position: 'top',
                },
                {//11
                    element: '#inputEditor',
                    intro: this.lang.getLang()["editor11"],
                    position: 'bottom',
                },
                {//12
                    element: '#canvasID',
                    intro: this.lang.getLang()["editor12"],
                    position: 'top',
                },
                {//13
                    element: '#root',
                    intro: this.lang.getLang()["editor13"],
                    position: 'left',
                }
            ]
        });

        //set CSS options
        this.setOptions(this.introEditor);

        //Bevor der schritt ausgeführt wird
        this.introEditor.onchange(function (targetElement) {
            this.step = this.step + 1;
            switch (this.step) {
                case 1:
                    break;
                case 2:
                    //remove next and skip button
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    ace.edit('inputEditor').setValue("repeat 4[repeat 4[fd 100 rt 90] fd 100]");
                    break;
                case 3:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                case 5:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                case 7:
                    ace.edit('editor').setValue(" to QUADRAT \n \n end");
                    break;
                case 8:
                    ace.edit('editor').setValue(" to QUADRAT \n \n end \n \n to DREIECK \n \n end");
                    break;
                case 9:
                    ace.edit('editor').setValue(" to QUADRAT \n \n end \n \n to QUADRAT \n \n end");
                    break;
                case 10:
                    ace.edit('editor').setValue(" to QUADRAT \n repeat 4[fd 100 rt 90] \n end");
                    break;
                case 11:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    ace.edit('inputEditor').setValue("QUADRAT");
                    break;
                case 12:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                default:
                    break;
            }
        }.bind(this));

        //Während der Schritt ausgeführt wird (kurz bevor es zum nächsten Schritt wechselt)
        this.introEditor.onbeforechange(function (targetElement) {
            switch (this.step) {
                case 1:
                    (<HTMLInputElement>document.getElementById('speedRange')).value = 9 + "";
                    break;
                case 3:
                    ace.edit('inputEditor').setValue("repeat 4[QUADRAT fd 100]");
                case 4:
                    //remove next and skip button
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    break;
                case 5:
                    this.inputComponent.executeCommand("cs ct", null, false);
                    break;
                default:
                    break;
            }
        }.bind(this));

    }

    private prepareIntro() {
        //set all option for how to display steps of tutorial
        this.intro.setOptions({
            steps: [
                {//1
                    element: '#root',
                    intro: this.lang.getLang()["intro1"],
                    position: 'left',
                },
                {//2
                    element: '#canvasD',
                    intro: this.lang.getLang()["intro2"],
                    position: 'top'
                },
                {//3
                    element: '#canvasID',
                    intro: this.lang.getLang()["intro3"],
                    position: 'top'
                },
                {//4
                    element: '#inputEditor',
                    intro: this.lang.getLang()["intro4"],
                    position: 'bottom'
                },
                {//5
                    element: '#canvasD',
                    intro: this.lang.getLang()["intro5"],
                    position: 'bottom'
                },
                {//6
                    element: '#inputEditor',
                    intro: this.lang.getLang()["intro6"],
                    position: 'bottom'
                },
                {//7
                    element: '#canvasD',
                    intro: this.lang.getLang()["intro7"],
                    position: 'bottom'
                },
                {//8
                    element: '#inputEditor',
                    intro: this.lang.getLang()["intro8"],
                    position: 'bottom'
                },
                {//9
                    element: '#history',
                    intro: this.lang.getLang()["intro9"],
                    position: 'top'
                },
                {//10
                    element: '#history',
                    intro: this.lang.getLang()["intro10"],
                    position: 'top'
                },
                {//11
                    element: '#root',
                    intro: this.lang.getLang()["intro11"],
                    position: 'left'
                },
                {//12
                    element: '#inputEditor',
                    intro: this.lang.getLang()["intro12"],
                    position: 'bottom'
                },
                {//13
                    element: '#history',
                    intro: this.lang.getLang()["intro13"],
                    position: 'top'
                },
                {//14
                    element: '#canvasID',
                    intro: this.lang.getLang()["intro14"],
                    position: 'top'
                },
            ]
        });

        //set CSS options
        this.setOptions(this.intro);

        //Bevor der schritt ausgeführt wird
        this.intro.onbeforechange(function (targetElement) {
            this.step = this.step + 1;
            switch (this.step) {
                case 1:
                    break;
                case 2:
                    (<HTMLInputElement>document.getElementById('speedRange')).value = 1 + "";
                    this.inputComponent.executeCommand("repeat 6[repeat 6[fd 200 rt 60] rt 60]", null, false);
                    (<HTMLInputElement>document.getElementById('speedRange')).value = 10 + "";
                    break;
                case 4:
                    ace.edit('inputEditor').setValue("fd 250");
                    break;
                case 14:
                    this.editor.setValue("");
                    this.inputComponent.executeCommand("cs ct", null, false);
                    break;
                default:
                    break;
            }
        }.bind(this));

        //Während der Schritt ausgeführt wird
        this.intro.onchange(function (targetElement) {
            switch (this.step) {
                case 3://turtle, which commands
                    this.inputComponent.executeCommand("cs", null, false);
                    break;
                case 4://Input: Example FD 250
                    //remove next and skip button
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    break;
                case 5:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                case 6://Input: CS
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    ace.edit('inputEditor').setValue("cs");
                    break;
                case 7:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                case 8: //Input: Example multiple commands
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    ace.edit('inputEditor').setValue("fd 200 rt 90 fd 200 rt 90 fd 200 rt 90 fd 200 rt 90");
                    (<HTMLInputElement>document.getElementById('speedRange')).value = 1 + "";
                    break;
                case 9://History
                    //make next and skip button visible again
                    (<HTMLInputElement>document.getElementById('speedRange')).value = 10 + "";
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                case 10:
                    break;
                case 11://Allgemein: Was passiert bei Fehlern?
                    this.inputComponent.executeCommand("cs", null, false);
                    break;
                case 12://Input: FD
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "hidden";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "hidden";
                    ace.edit('inputEditor').setValue("fd rt 90");
                    break;
                case 13:
                    (<any>document.querySelector('.introjs-nextbutton')).style.visibility = "visible";
                    (<any>document.querySelector('.introjs-skipbutton')).style.visibility = "visible";
                    break;
                default:
                    break;
            }
        }.bind(this));
    }

    setOptions(intro) {
        intro.setOption("overlayOpacity", "0.1");
        intro.setOption("nextLabel", String.fromCharCode(8614));
        intro.setOption("hidePrev", true);
        intro.setOption("hideNext", true);
        intro.setOption("showBullets", false);
        intro.setOption("scrollToElement", false);
        intro.setOption('tooltipPosition', 'left');
        intro.setOption('data-position', 'left');
        intro.setOption('showStepNumbers', false);
        intro.setOption('keyboardNavigation', false);
    }

    constructor(editor, inputComponent, headerComponent) {
        this.editor = editor;
        this.inputComponent = inputComponent;
        this.headerComponent = headerComponent;
        this.commandsService = headerComponent.commandsService;
        this.lang = headerComponent.la;

        // load library into variable intro
        this.intro = introJs();
        this.introEditor = introJs();
        this.introDebugger = introJs();

        //add onEventListener --> go to next step on ENTER
        document.getElementById("inputEditor").addEventListener("keyup", function (event) {
            if (event.which == 13 || event.keyCode == 13) {
                //click next-button (since it is not visible when showing code)
                (<any>document.querySelector('.introjs-nextbutton')).click();
                return false;
            }
            return true;
        });

        this.prepareIntro();
        this.prepareIntroEditor();
        this.prepareIntroDebugger();
    }

    public async startQuickstart() {
        //empty out all fields
        this.editor.setValue("");
        this.inputComponent.executeCommand("cs ct", null, false);

        this.step = 0;
        await this.intro.start();
    }

    public async startQuickstartEditor() {
        //empty out all fields
        this.editor.setValue("");
        this.inputComponent.executeCommand("cs ct", null, false);

        this.step = 0;
        await this.introEditor.start();
    }

    public async startQuickstartDebugger() {
        //empty out all fields
        this.editor.setValue("");
        this.inputComponent.executeCommand("cs ct", null, false);

        this.step = 0;
        await this.introDebugger.start();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/quickstart.service.ts